var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00016 3.33329L7.18158 7.36328C7.66306 7.73777 8.33727 7.73777 8.81875 7.36328L14.0002 3.33329M3.46683 13.3333H12.5335C13.2802 13.3333 13.6536 13.3333 13.9388 13.188C14.1897 13.0601 14.3937 12.8562 14.5215 12.6053C14.6668 12.3201 14.6668 11.9467 14.6668 11.2V4.79996C14.6668 4.05322 14.6668 3.67985 14.5215 3.39464C14.3937 3.14376 14.1897 2.93978 13.9388 2.81195C13.6536 2.66663 13.2802 2.66663 12.5335 2.66663H3.46683C2.72009 2.66663 2.34672 2.66663 2.06151 2.81195C1.81063 2.93978 1.60665 3.14376 1.47882 3.39464C1.3335 3.67985 1.3335 4.05322 1.3335 4.79996V11.2C1.3335 11.9467 1.3335 12.3201 1.47882 12.6053C1.60665 12.8562 1.81063 13.0601 2.06151 13.188C2.34672 13.3333 2.72009 13.3333 3.46683 13.3333Z",
    stroke: "#9898B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1f10712747be972a56b35c289dd94db1.svg";
export { ForwardRef as ReactComponent };